import { Summary } from '~/types';

interface SummaryDisplayProps {
  summary: Summary | null;
  isGenerating: boolean;
  error: string | null;
}

export function SummaryDisplay({ summary, isGenerating, error }: SummaryDisplayProps) {
  if (!summary && !isGenerating && !error) {
    return null;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>总结</h2>

      {isGenerating && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
          <div>正在生成总结...</div>
          <div style={{ marginTop: '10px', fontSize: '14px' }}>
            这可能需要几分钟时间，请耐心等待
          </div>
        </div>
      )}

      {error && (
        <div
          style={{
            padding: '15px',
            backgroundColor: '#f8d7da',
            border: '1px solid #f5c6cb',
            borderRadius: '4px',
            color: '#721c24',
          }}
        >
          <strong>错误:</strong> {error}
        </div>
      )}

      {summary && summary.status === 'done' && (
        <div>
          {/* Markdown Summary */}
          {summary.markdown && (
            <div
              style={{
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '4px',
              }}
            >
              <h3>内容总结</h3>
              <pre
                style={{
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                  fontFamily: 'inherit',
                  lineHeight: '1.6',
                }}
              >
                {summary.markdown}
              </pre>
            </div>
          )}

          {/* Action Items */}
          {summary.action_items && summary.action_items.length > 0 && (
            <div
              style={{
                padding: '15px',
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '4px',
              }}
            >
              <h3>行动项</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #ddd' }}>
                    <th style={{ padding: '10px', textAlign: 'left' }}>#</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>内容</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>优先级</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>状态</th>
                  </tr>
                </thead>
                <tbody>
                  {summary.action_items.map((item) => (
                    <tr key={item.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '10px' }}>{item.id}</td>
                      <td style={{ padding: '10px' }}>{item.text}</td>
                      <td style={{ padding: '10px' }}>
                        <span
                          style={{
                            padding: '3px 8px',
                            borderRadius: '3px',
                            fontSize: '12px',
                            backgroundColor:
                              item.priority === 'high'
                                ? '#f8d7da'
                                : item.priority === 'medium'
                                ? '#fff3cd'
                                : '#d1ecf1',
                            color:
                              item.priority === 'high'
                                ? '#721c24'
                                : item.priority === 'medium'
                                ? '#856404'
                                : '#0c5460',
                          }}
                        >
                          {item.priority === 'high'
                            ? '高'
                            : item.priority === 'medium'
                            ? '中'
                            : '低'}
                        </span>
                      </td>
                      <td style={{ padding: '10px' }}>
                        {item.status === 'pending' ? '待处理' : '已完成'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
